import { render, staticRenderFns } from "./DownloadAlert.vue?vue&type=template&id=2e669dad&scoped=true"
import script from "./DownloadAlert.vue?vue&type=script&lang=js"
export * from "./DownloadAlert.vue?vue&type=script&lang=js"
import style0 from "./DownloadAlert.vue?vue&type=style&index=0&id=2e669dad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e669dad",
  null
  
)

export default component.exports